











 

















const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MattermostProviderRowTeamMemberIntegrations",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "MattermostIntegration",
      "kind": "LinkedField",
      "name": "mattermost",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "TeamMemberIntegrationAuthWebhook",
          "kind": "LinkedField",
          "name": "auth",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "IntegrationProviderWebhook",
              "kind": "LinkedField",
              "name": "provider",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "TeamNotificationSettings",
          "kind": "LinkedField",
          "name": "teamNotificationSettings",
          "plural": false,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NotificationSettings_settings"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "TeamMemberIntegrations",
  "abstractKey": null
};

(node ).hash = "b40a389bd7ae6d9fb52bb564b99cddd4";

export default node;
